import { render, staticRenderFns } from "./TransferTool.vue?vue&type=template&id=17a35272&"
import script from "./TransferTool.vue?vue&type=script&lang=js&"
export * from "./TransferTool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports